<template>
    <component
        :is="containerComponent"
        v-bind="containerProps"
        @click="activateTab"
        v-if="isVisible"
    >
        <template v-if="!standalone" #title>
            <b-spinner v-if="showSpinner" type="border" small></b-spinner>
            {{ $t('prod_steps', { ns: 'production' }) }}
        </template>

        <b-card-text>
            <b-row class="mb-2" v-if="allowInsert">
                <b-col sm="2" class="mb-1">
                    <div class="d-flex">
                        <b-form-input
                            ref="newStepTimeInput"
                            :value="newStepTimeDisplay"
                            readonly
                            :placeholder="
                                $t('prod_gemaakt', { ns: 'production' })
                            "
                        />
                        <b-button
                            v-if="isBatchSteps"
                            @click.stop="setNewStepTimeNow"
                            class="bgc_aux_gray"
                            :disabled="!canAddStep"
                        >
                        </b-button>
                    </div>
                </b-col>
                <b-col sm="1" class="mb-1">
                    <b-form-input
                        v-model="newStep.tijdsduurNieuweStap"
                        :placeholder="$t('com_timespan', { ns: 'common' })"
                    />
                </b-col>
                <b-col sm="1" class="mb-1" v-if="recipeid == -1">
                    <b-form-input
                        v-model="newStep.programma"
                        :placeholder="
                            $t('prod_xprogramma', {
                                val: '',
                                ns: 'production'
                            })
                        "
                    />
                </b-col>
                <b-col sm="1" class="mb-1">
                    <b-form-input
                        v-model.number="newStep.stapNummer"
                        type="number"
                        step="1"
                        placeholder="#"
                    />
                </b-col>
                <b-col sm="2" class="mb-1">
                    <b-form-input
                        v-model="newStep.stapOmschrijving"
                        :placeholder="$t('com_omschrijving', { ns: 'common' })"
                    />
                </b-col>
                <b-col sm="2" class="mb-1">
                    <b-form-input
                        v-model.number="newStep.temperatuur"
                        type="number"
                        step="0.1"
                        :placeholder="$t('com_temperatuur', { ns: 'common' })"
                    />
                </b-col>
                <b-col sm="2" class="mb-1">
                    <b-form-input
                        v-model.number="newStep.hoeveelheid"
                        type="number"
                        step="0.1"
                        :placeholder="$t('com_amount', { ns: 'common' })"
                    />
                </b-col>
                <b-col sm="1" class="mb-1">
                    <b-button
                        @click.stop="addStep"
                        class="bgc_aux_normal"
                        :disabled="!canAddStep"
                        ><font-awesome-icon icon="arrow-down" size="1x" />
                    </b-button>
                </b-col>
            </b-row>

            <b-table
                striped
                responsive
                :fields="visibleFields"
                :items="stepsList"
                primary-key="stapNummer"
            >
                <template v-slot:cell(actions)="row">
                    <b-button
                        size="sm"
                        @click="verwijderItem(row.item)"
                        class="bgc_aux_alarm"
                        :disabled="!allowInsert"
                    >
                        <font-awesome-icon icon="trash-alt" size="1x" />
                    </b-button>
                </template>
            </b-table>
        </b-card-text>
    </component>
</template>
<script>
import { loadItem } from '../../models/DataHelper';
import DateHelper from '../../models/DateHelper';
import { EquipmentStepInfo } from '@/models/BakInfo';

export default {
    name: 'StepsInsert',
    data() {
        return {
            showSpinner: false,
            isVisible: true,
            stepsList: [],
            recipeSteps: [],
            recipeStepForNewStep: null,
            emittedListSignature: '',
            lastDeleted: null,
            newStep: {
                tijd: null,
                tijdsduurNieuweStap: null,
                programma: null,
                stapNummer: null,
                stapOmschrijving: null,
                temperatuur: null,
                hoeveelheid: null
            }
        };
    },
    props: {
        // lijst prop removed as it is no longer used
        action: {
            type: String
        },
        batchid: {
            type: Number,
            default: -1
        },
        recipeid: {
            type: Number,
            default: -1
        },
        paramName: {
            type: String
        },
        allowInsert: {
            type: Boolean,
            default: true
        },
        standalone: {
            type: Boolean,
            default: false
        }
    },
    watch: {},
    computed: {
        containerComponent() {
            return this.standalone ? 'div' : 'b-tab';
        },
        containerProps() {
            return this.standalone ? {} : { lazy: true };
        },
        isBatchSteps() {
            return this.action === 'production/loadLinkedOstData';
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                {
                    key: 'tijd',
                    label: this.$t('prod_gemaakt', { ns: 'production' }),
                    formatter: this.displayDateTime,
                    visible: true // this.recipeid == undefined
                },
                {
                    key: 'tijdsduurvolgende',
                    label: this.$t('com_timespan', { ns: 'common' }),
                    // formatter: (value, key, item) =>
                    //     value === undefined || value === null
                    //         ? item.tijdsduur
                    //         : value,
                    visible: true
                },
                {
                    key: 'programma',
                    label: this.$t('prod_xprogramma', {
                        val: '',
                        ns: 'production'
                    }),
                    visible: this.recipeid == -1
                },
                {
                    key: 'stapNummer',
                    label: '#',
                    visible: true
                },
                {
                    key: 'stapOmschrijving',
                    label: this.$t('com_omschrijving', { ns: 'common' }),
                    visible: true
                },
                {
                    key: 'temperatuur',
                    label: this.$t('com_temperatuur', { ns: 'common' }),
                    visible: true
                },
                {
                    key: 'hoeveelheid',
                    label: this.$t('com_amount', { ns: 'common' }),
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        canAddStep() {
            return (
                this.newStep.stapNummer !== null &&
                this.newStep.stapNummer !== undefined &&
                this.newStep.stapOmschrijving &&
                this.newStep.stapOmschrijving.trim().length > 0
            );
        },
        newStepTimeIso() {
            if (this.batchid > -1 && this.newStep.tijd) {
                return this.newStep.tijd;
            }
            return this.calculateStepTimeIso();
        },
        newStepTimeDisplay() {
            const date = new Date(this.newStepTimeIso);
            if (Number.isNaN(date.getTime())) {
                return '00:00';
            }
            const hh = String(date.getHours()).padStart(2, '0');
            const mm = String(date.getMinutes()).padStart(2, '0');
            return `${hh}:${mm}`;
        },
        recipeStepDifferences() {
            const recipeStep = this.recipeStepForNewStep;
            if (!recipeStep) {
                return [];
            }

            const fields = [
                ['stapOmschrijving', 'omschrijving'],
                ['temperatuur', 'temperatuur'],
                ['hoeveelheid', 'hoeveelheid'],
                ['programma', 'programma'],
                ['tijdsduurNieuweStap', 'tijdsduur']
            ];
            return fields
                .filter(([field]) => {
                    const expected =
                        field === 'tijdsduurNieuweStap'
                            ? this.getStepPreviousDuration(recipeStep)
                            : recipeStep[field];
                    const entered = this.newStep[field];
                    return (
                        expected !== null &&
                        expected !== undefined &&
                        String(expected) !== String(entered ?? '')
                    );
                })
                .map(([, label]) => label);
        }
    },
    methods: {
        activateTab() {
            if (!this.standalone) {
                this.loadStepData();
            }
        },
        displayDateTime(value) {
            return DateHelper.convertedToDateTimeShort(value, false);
        },
        toIsoDateTime(value) {
            if (!value) {
                return null;
            }
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return value;
            }
            return date.toISOString();
        },
        parseMinutes(value) {
            const minutes = Number(value ?? 0);
            return Number.isFinite(minutes) ? minutes : 0;
        },
        setNewStepTimeNow() {
            if (this.isBatchSteps) {
                this.newStep.tijd = new Date().toISOString();
            }
        },
        getBaseDateForNewStep() {
            if (!this.stepsList || this.stepsList.length < 1) {
                const base = new Date();
                // op 0 zetten als invoer voor recept is
                if (this.batchid == -1) {
                    base.setHours(0, 0, 0, 0);
                }
                return base;
            }

            const lastStep = this.stepsList[this.stepsList.length - 1];
            const parsedLastTime = new Date(lastStep?.tijd);
            if (Number.isNaN(parsedLastTime.getTime())) {
                const base = new Date();
                if (this.batchid == -1) {
                    base.setHours(0, 0, 0, 0);
                }
                return base;
            }

            return parsedLastTime;
        },
        calculateStepTimeIso() {
            if (!this.stepsList || this.stepsList.length < 1) {
                const first = new Date();
                if (this.batchid == -1) {
                    first.setHours(0, 0, 0, 0);
                }
                return first.toISOString();
            }

            const lastStep = this.stepsList[this.stepsList.length - 1];
            const baseDate = this.getBaseDateForNewStep();
            const tijdsduur = this.lastDeleted
                ? this.getStepPreviousDuration(this.lastDeleted)
                : this.getStepPreviousDuration(lastStep);
            const minutes = this.parseMinutes(tijdsduur);
            const nextDate = new Date(baseDate.getTime() + minutes * 60000);
            return nextDate.toISOString();
        },
        getStepPreviousDuration(step) {
            return step?.tijdsduurvorige ?? step?.tijdsduur ?? 0;
        },
        getListSignature(list) {
            try {
                return JSON.stringify(list ?? []);
            } catch {
                return '';
            }
        },
        emitStepsList() {
            const signature = this.getListSignature(this.stepsList);
            if (signature === this.emittedListSignature) {
                return;
            }
            if (this.emittedListSignature == '') {
                this.emittedListSignature = signature;
            } else {
                this.emittedListSignature = signature;
                this.$emit('input', this.stepsList);
                this.$emit('change', this.stepsList);
            }
        },
        getNextStepNumber() {
            if (!this.stepsList || this.stepsList.length < 1) {
                return 1;
            }
            const lastStep = this.stepsList[this.stepsList.length - 1];
            const stepNumber = Number(lastStep?.stapNummer ?? 0);
            return Number.isFinite(stepNumber) ? stepNumber + 1 : 1;
        },
        setValues() {
            this.newStep.stapNummer = this.getNextStepNumber();
            this.applyRecipeStepProposal();
            this.calculateStepTimeIso();
        },
        applyRecipeStepProposal() {
            this.recipeStepForNewStep =
                this.recipeSteps.find(
                    (step) =>
                        Number(step.stapNummer) ===
                        Number(this.newStep.stapNummer)
                ) ?? null;
            if (!this.recipeStepForNewStep) {
                return;
            }

            const recipeStep = this.recipeStepForNewStep;
            const fields = [
                ['tijdsduurNieuweStap', this.getStepPreviousDuration(recipeStep)],
                ['programma', recipeStep.programma],
                ['stapOmschrijving', recipeStep.stapOmschrijving],
                ['temperatuur', recipeStep.temperatuur],
                ['hoeveelheid', recipeStep.hoeveelheid]
            ];
            fields.forEach(([field, value]) => {
                if (
                    value !== null &&
                    value !== undefined
                ) {
                    this.newStep[field] = value;
                }
            });
        },
        resetNewStep() {
            this.newStep = {
                tijd: null,
                tijdsduurNieuweStap: null,
                programma: null,
                stapNummer: this.getNextStepNumber(),
                stapOmschrijving: null,
                temperatuur: null,
                hoeveelheid: null
            };
            // set focus to the ref newStepTimeInput input field after resetting the new step
            this.$nextTick(() => {
                this.$refs.newStepTimeInput?.focus();
            });
            this.applyRecipeStepProposal();
        },
        addStep() {
            if (!this.canAddStep) {
                return;
            }
            const step = new EquipmentStepInfo();
            step.bakID = this.batchid;
            step.tijd = this.newStepTimeIso;
            step.tijdsduur = this.newStep.tijdsduurNieuweStap;
            step.tijdsduurvorige = this.newStep.tijdsduurNieuweStap;
            step.programma = this.newStep.programma;
            step.stapNummer = this.newStep.stapNummer;
            step.stapOmschrijving = this.newStep.stapOmschrijving;
            step.temperatuur = this.newStep.temperatuur;
            step.hoeveelheid = this.newStep.hoeveelheid;

            this.stepsList = [...this.stepsList, step].sort((a, b) => {
                const stepA = a.stapNummer ?? 0;
                const stepB = b.stapNummer ?? 0;
                return stepA - stepB;
            });
            let prevStep = null;
            for (let i = 0; i < this.stepsList.length; i++) {
                if (prevStep) {
                    prevStep.tijdsduurvolgende = this.getStepPreviousDuration(prevStep);
                }
                prevStep = this.stepsList[i];
            }
            // verwijder de lastDeleted referentie na het toevoegen van een nieuwe stap
            this.lastDeleted = null;

            this.emitStepsList();
            this.$emit('added', step);
            this.resetNewStep();
        },
        async verwijderItem(item) {
            const doClose = await this.$root.showConfirmationBox(
                this.$t('com_delete', {
                    ns: 'common',
                    val: item.stapOmschrijving
                })
            );
            if (doClose === true) {
                const index = this.stepsList.indexOf(item);
                this.lastDeleted = item;
                if (index > -1) {
                    this.stepsList.splice(index, 1);
                    this.setValues();
                    for (let i = 0; i < this.stepsList.length; i++) {
                        this.stepsList[i].tijdsduurvolgende =
                            this.stepsList[i + 1]
                                ? this.getStepPreviousDuration(
                                      this.stepsList[i + 1]
                                  )
                                : null;
                    }
                    this.emitStepsList();
                }
            }
        },
        async loadStepData() {
            this.showSpinner = true;
            if (this.lijst != undefined) {
                this.stepsList = [...this.lijst];
                this.setValues();
                this.emitStepsList();
                this.showSpinner = false;
                return;
            }
            if (this.action) {
                this.showSpinner = true;
                const id = this.batchid > -1 ? this.batchid : this.recipeid;
                if (id > 0) {
                    this.stepsList = await loadItem(
                        this.action,
                        { [this.paramName]: id },
                        this.$t
                    );
                    if (this.batchid > -1 && this.recipeid > -1) {
                        this.recipeSteps = await loadItem(
                            'recipe/loadLinkedOstData',
                            { recipeid: this.recipeid },
                            this.$t
                        );
                    }
                    this.setValues();
                    this.emitStepsList();
                }
            }
            this.showSpinner = false;
        }
    },
    mounted() {
        if (this.standalone) {
            this.loadStepData();
        }
    },
    created() {}
};
</script>

<style scoped></style>
